/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair setting request.
 */
export interface MarketMakingPairSettingUpdateRequest {
  id: number;
  enabled: boolean;
  /**
   * Maker commission rate. 1 = 0.001%
   */
  makerCommissionRate: number;
  /**
   * Taker commission rate. 1 = 0.001%
   */
  takerCommissionRate: number;
  /**
   * Maker fee charged by LP. 1 = 0.001%
   */
  platformMakerFee: number;
  /**
   * Taker fee charged by LP. 1 = 0.001%
   */
  platformTakerFee: number;
  /**
   * In USD
   */
  maxLoss: number;
  lvl1: number;
  /**
   * Minimum bid-ask spread for level 1. 1 = 0.001%
   */
  minSpreadLvl1: number;
  lvl2: number;
  /**
   * Minimum bid-ask spread for level 2. 1 = 0.001%
   */
  minSpreadLvl2: number;
  lvl3: number;
  /**
   * Minimum bid-ask spread for level 3. 1 = 0.001%
   */
  minSpreadLvl3: number;
  lvl4: number;
  /**
   * Minimum bid-ask spread for level 4. 1 = 0.001%
   */
  minSpreadLvl4: number;
  lvl5: number;
  /**
   * Minimum bid-ask spread for level 5. 1 = 0.001%
   */
  minSpreadLvl5: number;
  compId: string;
  /**
   * Event detection LP. Can be from cross entity. Nullable.
   */
  eventDetectionLpId?: number;
  eventDetectionLpCrossedEntity: boolean;
  /**
   * Event detection parameter
   */
  eventDetectionBps: number;
}
